import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'
import countries from '@/collections/countries'
import productList from '@/data/productList' // product

const getCountry = (list = [], currentId = '') => {
  return list?.filter(({id}) => id === currentId)[0]?.id
}

const state = {
  ...stateAbstract,
  taxpayersDetail: {},
  taxpayersCount: null,
  taxpayersList: [],
  countriesCount: null,
  countriesList: countries,
  statesCount: null,
  statesList: [],
  documentTypesCount: null,
  document_typesList: [],
  currenciesCount: null,
  currenciesList: [],
  activitiesCount: null,
  activitiesList: [],
  referencesCount: null,
  referencesList: [],
  isExpandNavigationDrawer: false,
  isTestMode: false,
  query: {},
  currentProduct: ''
}

const getters = {
  currentStates: (state, _, rootState) => {
    return state.countriesList?.find(({id}) => id === getCountry(state.countriesList, rootState.auth?.account?.country))?.states ?? []
  },
  currentCountry: (state, _, rootState) => {
    return state.countriesList?.filter(({id}) => id === getCountry(state.countriesList, rootState.auth?.account?.country))[0]?.id
  },
  currentProduct: (state) => {
    return productList.find(({id}) => id === state.currentProduct ?? 'pos')
  }
}

const mutations = {
  EXPAND_NAVIGATION_DRAWER: (state, response) => {
    state.isExpandNavigationDrawer = response
  },
  TEST_MODE: (state, response) => {
    state.isTestMode = response
  },
  SET_QUERY: (state, query) => {
    state.query = query
  },
  SET_PRODUCT: (state, product) => {
    state.currentProduct = product ?? 'pos'
  },
  ...mutationsAbstract
}

export default {
  namespaced: true,
  getters,
  state,
  actions: actionsAbstract,
  mutations
}